import {RuleBundleModel} from '../../../../../../models/api/ruleBundleModel';
import {RuleModel} from '../../../../../../models/api/ruleModel';
import {TagModel} from '../../../../../../models/api/tagModel';
import {DelayParam} from '../../../../../editors/commons/paramModel';
import {RuleEditorState, RuleState} from '../../../state/ruleEditorState';

export interface CsatTagsModels {
  sent: TagModel;
  scheduled: TagModel;
}

export enum CsatEditorSubsetsEnum {
  SCHEDULED = 'scheduled',
  SENT = 'sent',
}

export interface CsatEditorSpecificState {
  delaySinceTrigger: DelayParam;
  tags: {
    scheduled: number;
    sent: number;
  };
  response?: number;
  actions: {
    scheduled: RuleState['actions'];
    sent: RuleState['actions'];
  };

  initialRules?: {
    sentRule: RuleModel;
    scheduledRule: RuleModel;
    unscheduleRule?: RuleModel;
    bundle: RuleBundleModel;
  };
}

export type CsatEditorState = RuleEditorState & {csatState: CsatEditorSpecificState};
